import React from 'react';

/**
 * Lightweight replacement for Atlaskit Lozenge.
 *
 * @param {Object} props - Component props.
 * @param {React$Node} props.children - Inner content.
 * @param {boolean} props.isBold - Whether to use a bold font weight.
 * @returns {React$Node}
 */
export default function Lozenge({ children, isBold }) {
    return (
        <span
            style = {{
                background: 'transparent',
                color: 'inherit',
                display: 'inline-flex',
                fontSize: '12px',
                fontWeight: isBold ? 700 : 500,
                letterSpacing: '0.02em',
                lineHeight: 1.2,
                padding: '2px 6px',
                textTransform: 'uppercase'
            }}>
            {children}
        </span>
    );
}
